var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase-method-detail-file-info"},[(_vm.fileFuns.get)?_c('file-manage',{attrs:{"file-data-ids":_vm.data.fileIds,"funs":_vm.fileFuns},on:{"addFile":_vm.addFile,"delFile":_vm.delFile}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }